import { CheckCircle2, ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import Reveal from "./Reveal";
import { scrollToId } from "@/lib/scroll";

const COPAS_IMG = "/catalog/grabado-copas.jpg";
const CORCHOS_IMG = "/catalog/grabado-tapones.jpg";
const DECANTADORES_IMG = "/catalog/grabado-decantadores.jpg";

const CARD_META = [
  { id: "grabado-copas", img: COPAS_IMG },
  { id: "grabado-tapones", img: CORCHOS_IMG },
  { id: "grabado-decantadores-vino", img: DECANTADORES_IMG },
];

export default function Specialties() {
  const { t } = useTranslation();
  const cardsText = t("specialties.cards", { returnObjects: true });
  const CARDS = CARD_META.map((m, i) => ({ ...m, ...cardsText[i] }));

  const preset = (id) => {
    window.dispatchEvent(new CustomEvent("luv:product", { detail: id }));
    scrollToId("#presupuesto");
  };

  return (
    <section id="especialidades" data-testid="specialties-section" className="max-w-7xl mx-auto px-4 sm:px-6 py-20 sm:py-28">
      <Reveal className="max-w-3xl">
        <div className="text-xs uppercase tracking-[0.28em] text-[#F5CB5C] font-semibold">{t("specialties.kicker")}</div>
        <h2 className="mt-4 font-display text-white text-2xl sm:text-3xl lg:text-4xl leading-tight">
          {t("specialties.title1")} <span className="text-gold-gradient">{t("specialties.titleHighlight")}</span>
        </h2>
        <p className="mt-5 text-sm sm:text-base text-gray-400 leading-relaxed">
          {t("specialties.desc")}
        </p>
      </Reveal>

      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        {CARDS.map((c, i) => (
          <Reveal key={c.id} delay={i * 0.1}>
            <article
              data-testid={`specialty-${c.id}-card`}
              className="glass-card glass-lift rounded-3xl overflow-hidden h-full flex flex-col relative"
            >
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(163,29,61,0.22),transparent_65%)] pointer-events-none" />
              <div className="img-zoom relative">
                <img src={c.img} alt={c.alt} className="w-full h-60 sm:h-72 object-cover" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B0E14] via-transparent to-transparent pointer-events-none" />
              </div>
              <div className="relative p-6 sm:p-8 flex flex-col flex-1">
                <h3 className="font-display text-white text-xl sm:text-2xl">{c.title}</h3>
                <p className="mt-3 text-sm text-gray-400 leading-relaxed">{c.desc}</p>
                <ul className="mt-5 space-y-2.5 flex-1">
                  {c.features.map((f) => (
                    <li key={f} className="flex items-start gap-2.5 text-sm text-gray-300">
                      <CheckCircle2 size={16} className="text-[#F5CB5C] mt-0.5 shrink-0" />
                      {f}
                    </li>
                  ))}
                </ul>
                <div className="mt-7 flex items-center justify-between gap-4 border-t border-[#F5CB5C]/10 pt-5">
                  <span data-testid={`specialty-${c.id}-price`} className="font-display text-lg text-gold-gradient whitespace-nowrap">
                    {c.price}
                  </span>
                  <button
                    data-testid={`specialty-${c.id}-cta`}
                    onClick={() => preset(c.id)}
                    className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#F5CB5C] hover:gap-3 transition-all duration-300"
                  >
                    {t("specialties.ctaLabel")} <ArrowRight size={16} />
                  </button>
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
